const hasPositionChanged = ({ pos, prevPos }) => pos !== prevPos;

const valueInRange = ({ minScale, maxScale, scale }) => scale <= maxScale && scale >= minScale;

const getTranslate = ({ minScale, maxScale, scale }) => ({ pos, prevPos, translate }) =>
    valueInRange({ minScale, maxScale, scale }) && hasPositionChanged({ pos, prevPos })
        ? translate + (pos - prevPos * scale) * (1 - 1 / scale)
        : translate;

const getScale = ({ scale, minScale, maxScale, scaleSensitivity, deltaScale }) => {
    let newScale = scale + (deltaScale / (scaleSensitivity / scale));
    newScale = Math.max(minScale, Math.min(newScale, maxScale));
    return [scale, newScale];
};

const getMatrix = ({ scale, translateX, translateY }) => `matrix(${scale}, 0, 0, ${scale}, ${translateX}, ${translateY})`;

const pan = ({ state, originX, originY }) => {
    const minX = (state.transformation.originX*state.transformation.scale)-state.transformation.originX;
    const minY = (state.transformation.originY*state.transformation.scale)-state.transformation.originY;
    const maxX = (minX - (state.element.offsetWidth*state.transformation.scale)) + state.element.offsetParent.offsetWidth;
    const maxY = (minY - (state.element.offsetHeight*state.transformation.scale)) + state.element.offsetParent.offsetHeight;

    const resX = state.transformation.translateX + originX;
    const resY = state.transformation.translateY + originY;
    state.transformation.translateX = resX > minX ? minX : resX < maxX ? maxX : resX;
    state.transformation.translateY = resY > minY ? minY : resY < maxY ? maxY : resY;


    //OLD PANING
    //state.transformation.translateX += originX;
    //state.transformation.translateY += originY;
    state.element.style.transform = getMatrix({ scale: state.transformation.scale, translateX: state.transformation.translateX, translateY: state.transformation.translateY });
};

const makePan = (state) => ({
    panBy: ({ originX, originY }) => pan({ state, originX, originY }),
    panTo: ({ originX, originY, scale }) => {
        state.transformation.scale = scale;
        pan({ state, originX: originX - state.transformation.translateX, originY: originY - state.transformation.translateY });
    },
});

const makeZoom = (state) => ({
    zoom: ({ x, y, deltaScale }) => {
        const { left, top } = state.element.getBoundingClientRect();
        const { minScale, maxScale, scaleSensitivity } = state;
        const [ scale, newScale ] = getScale({ scale: state.transformation.scale, deltaScale, minScale, maxScale, scaleSensitivity });
        const originX = x - left;
        const originY = y - top;
        const newOriginX = originX / scale;
        const newOriginY = originY / scale;
        const translate = getTranslate({ scale, minScale, maxScale });

        let translateX = translate({ pos: originX, prevPos: state.transformation.originX, translate: state.transformation.translateX });
        let translateY = translate({ pos: originY, prevPos: state.transformation.originY, translate: state.transformation.translateY });

        const minX = (newOriginX*newScale)-newOriginX;
        const minY = (newOriginY*newScale)-newOriginY;
        const maxX = (minX - (state.element.offsetWidth*newScale)) + state.element.offsetParent.offsetWidth;
        const maxY = (minY - (state.element.offsetHeight*newScale)) + state.element.offsetParent.offsetHeight;

        translateX = translateX > minX ? minX : translateX < maxX ? maxX : translateX;
        translateY = translateY > minY ? minY : translateY < maxY ? maxY : translateY;

        state.element.style.transformOrigin = `${newOriginX}px ${newOriginY}px`;
        state.element.style.transform = getMatrix({ scale: newScale, translateX, translateY });
        state.transformation = { originX: newOriginX, originY: newOriginY, translateX, translateY, scale: newScale };
    }
});

const makeState = (state) => ({
    getState: () => {
        return state;
    }
});

export function renderer ({ minScale, maxScale, element, scaleSensitivity = 10, defaultOriginX = 0, defaultOriginY = 0, translateX = 0, translateY = 0, deltaScale = 2}) {
    const state = {
        element,
        minScale,
        maxScale,
        scaleSensitivity,
        transformation: {
            originX: defaultOriginX,
            originY: defaultOriginY,
            translateX: translateX,
            translateY: translateY,
            scale: 1
        },
    };
    const instance = Object.assign({}, makeZoom(state), makePan(state), makeState(state));
    instance.zoom({
        deltaScale: deltaScale,
        x: defaultOriginX,
        y: defaultOriginY
    })
    return instance;
}